export default __webpack_public_path__ + "static/media/data-science.7e444bb2.jpg";